<template>
  <div id="app" class="app-wrapper">
    <HeaderElem />
    <div class="app-content">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <FooterElem />
  </div>
</template>

<script>
import HeaderElem from "@/components/Header";
import FooterElem from "@/components/Footer";

export default {
  name: "App",
  components: {
    HeaderElem,
    FooterElem,
  },
};
</script>
